var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Provider } from "react-redux";
import { utilEnvironment } from "../../utils/utilEnvironment";
import { asyncComponent } from "../generic/asyncComponent";
import { LocaManager } from "../loca/LocaManager";
import { ModalManager } from "../modals/ModalManager";
import { Overlay } from "../overlay/Overlay";
import { SceneManagerDOM } from "../scenes/SceneManagerDOM";
import { DialogTutorial } from "../tutorial/components/DialogTutorial";
var Cheats;
var DevTools;
if (!utilEnvironment.isTest()) {
    if (!utilEnvironment.isProduction()) {
        var cheatImporter = function () { return import("../cheats/CheatsDOM"); };
        var CheatsModule = asyncComponent("CheatsDOM", cheatImporter);
        Cheats = React.createElement(CheatsModule, null);
    }
    if (utilEnvironment.isDevelopment()) {
        var devToolsImporter = function () { return import("../../setup/DevTools"); };
        var DevToolsModule = asyncComponent("DevTools", devToolsImporter);
        DevTools = React.createElement(DevToolsModule, null);
    }
}
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        return (React.createElement(Provider, { store: this.props.store },
            React.createElement(LocaManager, null,
                React.createElement(SceneManagerDOM, null),
                React.createElement(ModalManager, null),
                React.createElement(Overlay, null),
                React.createElement(DialogTutorial, null),
                Cheats,
                DevTools)));
    };
    return App;
}(React.Component));
export { App };



//////////////////
// WEBPACK FOOTER
// ./src/features/app/App.tsx
// module id = 1098
// module chunks = 3